/** @format */

import styled from "styled-components";
import { colors, fonts, mixins } from "../../../../css/variables";
import { FlexBox } from "../../../layouts/FlexBox";
import { FormWrap } from "../../../layouts/FormWrap";
import { Button } from "../../../ui-parts/ocnk";
import useEconomicEstimateElementHooks from "../../../../hooks/useEconomicEstimateElementHooks";
import AnotherTabLink from "../../../ui-parts/ocnk/AnotherTabLink";
import useNavigateByAgent from "../../../../hooks/useNavigateByAgentHooks";
import BcartEconomicEstimateTable from "../../../ui-parts/bcart/EconomicEstimate/EconomicEstimateTable";

const BlueWraper = styled.div`
  background-color: ${colors.themeColor("background_whitegray")};
  border: solid 1px ${colors.themeColor("border_box")};
  border-radius: 8px;
  padding: 20px;
`;

const UL = styled.ul`
  list-style: inherit;
  padding-left: 20px;
  li {
    font-size: ${fonts.fontSizeRem("ms")};
    ${mixins.screenUnder()} {
      font-size: ${fonts.fontSizeRem("xs")};
    }
  }
`;

const BcartEconomicEstimateCheckElement = ({ redirect }: { redirect?: boolean }) => {
  const { navigateByAgent } = useNavigateByAgent();
  const { feeArray, EconomicInfoData, sumFeeInfoData, creditPaymentSiteFeeState, zMasterInfoData, navigateBack } =
    useEconomicEstimateElementHooks(navigateByAgent, redirect);

  return (
    <FormWrap width={700} padding={36}>
      <h1 className="mt0">ご利用料金</h1>
      <p>ご利用料金は以下の通りです。</p>
      <h2 className="mt40 mb20">クレジットカード決済({zMasterInfoData.z_account_name})</h2>
      <BcartEconomicEstimateTable
        contentName={"credit"}
        sumSystemCost={sumFeeInfoData.credit}
        options={feeArray.credit}
        salesHandleFee
        paymentSiteFee={creditPaymentSiteFeeState}
        page={"economic_estimate"}
      />
      <UL>
        <li>上記料金はすべて税別表記となります。</li>
        <li>
          支払サイト：月末の支払日が土日祝日の場合は、「前営業日」での支払いになりますが、月末以外の支払日が土日祝日の場合は、「翌営業日」での支払いになります。
        </li>
        <li>
          月3回締め3回払いの場合、特定月（4月、10月、12月）の未締め分の支払日は、翌月15日となりますのであらかじめご注意ください。
        </li>
        <li>
          支払サイトの<span className="bold">振込手数料はゼウス負担</span>となります。
        </li>
        <li>取引手数料の支払い方法は、各月の売上金から相殺となります。</li>
      </UL>
      <h2 className="mt40 mb20">お申し込みの前にご確認ください</h2>
      <BlueWraper>
        <FlexBox column gap={4} mt={0}>
          <AnotherTabLink href={"https://www.cardservice.co.jp/guide/preparation.html#anchor-08"}>
            取扱不可商材について
          </AnotherTabLink>
          {EconomicInfoData.cvs.system_setting.select_flag && (
            <AnotherTabLink href={"https://www.cardservice.co.jp/guide/cvs.html"}>
              コンビニサービス導入基準
            </AnotherTabLink>
          )}
        </FlexBox>
      </BlueWraper>
      <h2 className="mt40 mb0">規約等のご確認と同意</h2>
      <p className="font-ms mt16">お申し込みには各種利用規約等への同意が必要です。</p>
      <BlueWraper>
        <FlexBox column gap={4} mt={0}>
          <AnotherTabLink href={"https://www.cardservice.co.jp/zmc/kiyaku/pdf/notation_privacy.pdf"}>
            個人情報の取扱いについて
          </AnotherTabLink>
          <AnotherTabLink href={"https://www.cardservice.co.jp/zmc/kiyaku/pdf/notation_kyotsu.pdf"}>
            ゼウス決済サービス共通規約
          </AnotherTabLink>
          {EconomicInfoData.credit.system_setting.select_flag && (
            <AnotherTabLink href={"https://www.cardservice.co.jp/zmc/kiyaku/pdf/notation_creditcard.pdf"}>
              クレジット決済サービス利用規約（包括加盟型 ）
            </AnotherTabLink>
          )}
        </FlexBox>
      </BlueWraper>
      <FlexBox mt={24} gap={16}>
        <Button variant="secoundary" onClick={navigateBack}>
          戻る
        </Button>
      </FlexBox>
    </FormWrap>
  );
};

export default BcartEconomicEstimateCheckElement;
